// extracted by mini-css-extract-plugin
export default {"card":"OrganizationCardSkeleton_card__IU7GT","CardFooter":"OrganizationCardSkeleton_CardFooter__kXKFs","cardTitle":"OrganizationCardSkeleton_cardTitle__ExwLQ"};